var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16_4302)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.7367 20.2378L27.9012 5.50164C27.0713 4.77535 26.0312 4.41162 24.9912 4.41162C23.95 4.41162 22.9099 4.77535 22.08 5.50164L5.24448 20.2378C2.23295 22.8746 3.23286 27.7774 8.15803 27.7774H9.29016V39.6061C9.29016 42.5031 11.676 44.8516 14.6191 44.8516H35.3621C38.3052 44.8516 40.691 42.5031 40.691 39.6061V27.7774H41.8232C46.7483 27.7774 47.7482 22.8734 44.7367 20.2378ZM30.594 34.1246C30.594 35.1565 29.7452 35.992 28.6969 35.992H21.2855C20.2372 35.992 19.3884 35.1565 19.3884 34.1246V29.7296C19.3884 26.6838 21.897 24.2144 24.9912 24.2144C28.0854 24.2144 30.594 26.6838 30.594 29.7296V34.1246Z",
    fill: "#FFA800"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16_4302"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.8922,
    height: 40.4412,
    fill: "white",
    transform: "translate(3.55011 4.41187)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.ea36eb54870e8121ccbafdff75816434.svg";
export { ForwardRef as ReactComponent };